import RolesListPage from '../RolesListPage/RolesListPage';
import TeamMembersListPage from '../TeamMembersListPage/TeamMembersListPage';
import { InvitePeoplePage } from '../InvitePeoplePage/InvitePeoplePage';
import { NewRolePage, EditRolePage, ViewRolePage } from '../RolePage/RolePageContainer';
import EditPermissionsPage from '../EditPermissionsPage/EditPermissionsPage';

const getParent = (parentId) => () => routes.find(({ id }) => id === parentId);

export const setRouteTitle = (id, title) =>  routes.find(route => route.id === id).title = title;

const routes = [
    {
      id: 'teammates',
      title: 'breadcrumbs.teammates',
      path: '/',
      matchPath: '/team',
      component: TeamMembersListPage,
      exact: true
    },
    {
      id: 'roles',
      title: 'breadcrumbs.roles',
      path: '/roles',
      component: RolesListPage,
      getParent: getParent('teammates')
    },
    {
      id: 'invite',
      dynamicValue: true,
      path: '/invite',
      component: InvitePeoplePage,
      getParent: getParent('teammates')
    },
    {
      id: 'editPermissions',
      title: 'breadcrumbs.permissions.edit',
      path: '/permissions/edit/:id',
      component: EditPermissionsPage,
      getParent: getParent('teammates')
    },
    {
      id: 'newRole',
      path: '/role/new',
      dynamicValue: true,
      component: NewRolePage,
      getParent: getParent('roles'),
    },
    {
      id: 'editRole',
      path: '/role/:id/edit',
      dynamicValue: true,
      component: EditRolePage,
      getParent: getParent('roles'),
    },
    {
      id: 'viewRole',
      path: '/role/:id',
      dynamicValue: true,
      component: ViewRolePage,
      getParent: getParent('roles'),
    },
];

export default routes;
